import ShopaholicAddWishList from "@lovata/shopaholic-wish-list/shopaholic-add-wish-list";
import ShopaholicRemoveWishList from '@lovata/shopaholic-wish-list/shopaholic-remove-wish-list';
import ShopaholicCartAdd from '@lovata/shopaholic-cart/shopaholic-cart-add';
import ShopaholicCartRemove from '@lovata/shopaholic-cart/shopaholic-cart-remove';
import ShopaholicCouponAdd from "@lovata/shopaholic-coupon/shopaholic-coupon-add";
import ShopaholicCouponRemove from "@lovata/shopaholic-coupon/shopaholic-coupon-remove";
import ShopaholicCartUpdate from '@lovata/shopaholic-cart/shopaholic-cart-update';
import ShopaholicCartRestore from '@lovata/shopaholic-cart/shopaholic-cart-restore';


export default new class CatalogItem {
    constructor() {
        this.obShopaholicCartUpdate = new ShopaholicCartUpdate();
        this.obShopaholicCartRemove = new ShopaholicCartRemove();
        this.obShopaholicCartRestore = new ShopaholicCartRestore();

        this.obShopaholicCouponAdd = new ShopaholicCouponAdd();

        this.obAddWishListHelper = new ShopaholicAddWishList();
        this.obRemoveWishListHelper = new ShopaholicRemoveWishList();

        this.preLoaderSelector = '.preloader';
        this.catalogWrapper = 'catalog';
        this.miniCartWrapper = 'minicart';
        this.miniWishListWrapper = 'miniwishlist';
        this.offcanvasCartWrapper = 'cart-offcanvas';
        this.cartTableWrapper = 'cart-table';
        this.cartTotalWrapper = 'cart-total';

        this.wishListButtonActive = 'tm-action-button-active';


        this.restoreSelector = 'item-restore';
        this.positionSelector = '_shopaholic-product-wrapper';
        this.cardNodeSelector = 'cart-product';
        this.hideClass = 'uk-hidden';



        this.handlers();
        this.initCouponHandlers();
        this.initUpdateCartQuantity()
        this.initRestoreButton();

    }

    handlers() {
        this.addListenerToAddWishListButton();
        this.addListenerToAddCartButton();
        this.addListenerRemoveFromCartButton();
        this.addListenerToRemoveWishListButton();
    }


    addListenerToAddWishListButton() {
        this.obAddWishListHelper.setAjaxRequestCallback((obRequestData, obButton) => {
            obRequestData.update = {
                'shop/miniwishlist': `#${this.miniWishListWrapper}`,
                // 'shop/catalog': `#${this.catalogWrapper}`,
            };
            obRequestData.loading = this.preLoaderSelector;
            obRequestData.complete = () => {
                UIkit.notification({message: 'Добавлено в избранное', status: 'success'});
                obButton.removeClass(this.obAddWishListHelper.sDefaultButtonClass);
                obButton.addClass(this.wishListButtonActive);
                obButton.addClass(this.obRemoveWishListHelper.sDefaultButtonClass);
            };
            return obRequestData;
        }).init();
    }

    addListenerToRemoveWishListButton() {
        this.obRemoveWishListHelper.setAjaxRequestCallback((obRequestData, obButton) => {
            obRequestData.update = {
                'shop/miniwishlist': `#${this.miniWishListWrapper}`,
                // 'shop/catalog': `#${this.catalogWrapper}`,
            };
            obRequestData.loading = this.preLoaderSelector;
            obRequestData.complete = () => {
                UIkit.notification({message: 'Removed from wishlist', status: 'success'});
                obButton.removeClass(this.obRemoveWishListHelper.sDefaultButtonClass);
                obButton.removeClass(this.wishListButtonActive);
                obButton.addClass(this.obAddWishListHelper.sDefaultButtonClass);
            };
            return obRequestData;
        }).init();
    }

    addListenerToAddCartButton() {
        const obShopaholicCartAdd = new ShopaholicCartAdd();
        obShopaholicCartAdd.setAjaxRequestCallback((obRequestData, obButton) => {
            obRequestData.update = {
                'shop/minicart': `#${this.miniCartWrapper}`,
                'offcanvas/cart': `#${this.offcanvasCartWrapper}`,
                // 'shop/catalog': `#${this.catalogWrapper}`,
            };
            obRequestData.loading = this.preLoaderSelector;

            obRequestData.complete = () => {
                this.openMiniCart();
                obButton.removeAttribute('disabled');
            };
            return obRequestData;
        }).init();
    }

    addListenerRemoveFromCartButton() {
        const obShopaholicCartRemove = new ShopaholicCartRemove();
        obShopaholicCartRemove.setAjaxRequestCallback((obRequestData, obButton) => {
            obRequestData.update = {
                'shop/minicart': `.${this.miniCartWrapper}`,
                'offcanvas/cart': `#${this.offcanvasCartWrapper}`,
                // 'cart/table': `#${this.cartTableWrapper}`,
                'cart/total': `#${this.cartTotalWrapper}`,
            };
            obRequestData.loading = '.preloaderr';
            obRequestData.complete = ({ responseJSON }) => {
                const obCard = $(obButton).parents(`.${this.positionSelector}`);
                this.showRestoreSection(obCard);
                this.obShopaholicCartRemove.completeCallback(responseJSON, obButton);
            };
            // obRequestData.complete = () => {
            //     UIkit.notification({message: 'Deleted from cart', status: 'danger'})
            // };
            return obRequestData;
        }).init();
    }

    initRestoreButton() {
        this.obShopaholicCartRestore.setAjaxRequestCallback((obRequestData, obButton) => {

            obRequestData.update = {
                'shop/minicart': `.${this.miniCartWrapper}`,
                'offcanvas/cart': `#${this.offcanvasCartWrapper}`,
                'cart/total': `#${this.cartTotalWrapper}`,
            };

            obRequestData.complete = ({ responseJSON }) => {
                const obCard = $(obButton).parents(`.${this.positionSelector}`);
                this.hideRestoreSection(obCard);
                this.obShopaholicCartRemove.completeCallback(responseJSON, obButton);
            };

            return obRequestData;
        }).init();
    }
    hideRestoreSection(obCard) {
        const restoreNode = $(obCard).find(`.${this.restoreSelector}`);
        const cartNode = $(obCard).find(`.${this.cardNodeSelector}`);

        cartNode.removeClass(this.hideClass);
        restoreNode
            .addClass(this.hideClass)
            .attr('aria-hidden', true)
            .find(`.${this.obShopaholicCartRestore.sDefaultButtonClass}`)
            .attr('tabindex', '-1');
    }
    showRestoreSection(obCard) {
        const restoreNode = $(obCard).find(`.${this.restoreSelector}`);
        const cartNode = $(obCard).find(`.${this.cardNodeSelector}`);

        cartNode.addClass(this.hideClass);
        restoreNode
            .removeClass(this.hideClass)
            .attr('aria-hidden', false)
            .find(`.${this.obShopaholicCartRestore.sDefaultButtonClass}`)
            .attr('tabindex', '0')
            .focus();
    }

    initUpdateCartQuantity() {
        const obShopaholicCartUpdate = new ShopaholicCartUpdate();
        obShopaholicCartUpdate.setAjaxRequestCallback((obRequestData) => {
            obRequestData.update = {
                'shop/minicart': `.${this.miniCartWrapper}`,
                'cart/table': `#${this.cartTableWrapper}`,
                'offcanvas/cart': `#${this.offcanvasCartWrapper}`,

            };
            obRequestData.loading = '.preloader';
            return obRequestData;
        }).init();
    }

    initCouponHandlers() {
        const obShopaholicCouponAdd = new ShopaholicCouponAdd();
        const obShopaholicCouponRemove = new ShopaholicCouponRemove();

        obShopaholicCouponAdd.setAjaxRequestCallback((obRequestData) => {
            obRequestData.loading = '.preloader';
            obRequestData.update = {
                'offcanvas/cart': `#${this.offcanvasCartWrapper}`,
                'cart/table': `#${this.cartTableWrapper}`,
                'cart/total': `#${this.cartTotalWrapper}`,
            };
            obRequestData.complete = ({ responseJSON }) => {
                this.obShopaholicCouponAdd.completeCallback(responseJSON);
                if (responseJSON.status !== false) {
                    UIkit.notification({message: 'Coupon applied', status: 'success'})
                } else {
                    UIkit.notification({message: 'Wrong coupon', status: 'danger'})
                }
            };

            // obRequestData.complete = () => {
            //     const obApplyButton = document.querySelector(`.${obShopaholicCouponAdd.sButtonClass}`);
            //     const obRemoveButton = document.querySelector(`.${obShopaholicCouponRemove.sButtonClass}`);
            //     if (obApplyButton) {
            //         obApplyButton.classList.add(this.hideClass);
            //     }
            //     if (obRemoveButton) {
            //         obRemoveButton.classList.remove(this.hideClass);
            //     }
            // };

            return obRequestData;
        })
            .init();
        obShopaholicCouponRemove.setAjaxRequestCallback((obRequestData) => {
            obRequestData.loading = '.preloader';
            obRequestData.update = {
                'offcanvas/cart': `#${this.offcanvasCartWrapper}`,
                'cart/table': `#${this.cartTableWrapper}`,
                'cart/total': `#${this.cartTotalWrapper}`,
            };
            obRequestData.complete = () => {
                UIkit.notification({message: 'Coupon deleted', status: 'danger'})
            };
            // obRequestData.complete = () => {
            //     const obApplyButton = document.querySelector(`.${obShopaholicCouponAdd.sButtonClass}`);
            //     const obRemoveButton = document.querySelector(`.${obShopaholicCouponRemove.sButtonClass}`);
            //     if (obApplyButton) {
            //         obApplyButton.classList.remove(this.hideClass);
            //     }
            //     if (obRemoveButton) {
            //         obRemoveButton.classList.add(this.hideClass);
            //     }
            // };

            return obRequestData;
        })
            .init();
    }

    openMiniCart() {
        UIkit.offcanvas('#cart-offcanvas').show();
    }
}();
